// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.has-margin[data-v-39959eda] {\n\tmargin-right: 0.5em;\n}\n.left-margin[data-v-39959eda] {\n\tmargin-left: 0.5em;\n}\n", ""]);
// Exports
module.exports = exports;
